import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CodeBlock = ({ text }) => {
    const theme = useTheme();

    return (
        <Typography sx={{ fontFamily: 'monospace', background: theme.palette.background.paper, p: 1, borderRadius: 1, mt: 1, mb: 2 }}>
            {text}
        </Typography>

    );
};

export default CodeBlock;
